import { Fragment, MarkType, Node, Schema, Slice } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

import { ensureHttps } from '../utils';

const HTTP_LINK_REGEX =
  /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b(?:[-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
const linkify = (fragment: Fragment, markType: MarkType): Fragment => {
  const linkified: Node[] = [];
  fragment.forEach((child: Node) => {
    if (child.isText) {
      const text = child.text as string;
      let pos = 0,
        match;

      while ((match = HTTP_LINK_REGEX.exec(text))) {
        const start = match.index;
        const end = start + match[0].length;
        const link = markType;

        // simply copy across the text from before the match
        if (start > 0) {
          linkified.push(child.cut(pos, start));
        }

        const urlText = ensureHttps(text.slice(start, end));
        const cut = child.cut(start, end);
        (cut as any).text = urlText;
        linkified.push(
          cut.mark(link.create({ href: urlText }).addToSet(child.marks)),
        );
        pos = end;
      }

      // copy over whatever is left
      if (pos < text.length) {
        linkified.push(child.cut(pos));
      }
    } else {
      linkified.push(child.copy(linkify(child.content, markType)));
    }
  });

  return Fragment.fromArray(linkified);
};

export function linkifyPastePlugin(schema: Schema) {
  return new Plugin({
    props: {
      transformPasted: (slice: Slice) => {
        return new Slice(
          linkify(slice.content, schema.marks.link),
          slice.openStart,
          slice.openEnd,
        );
      },
    },
  });
}
